import { useEffect } from "react";

const AuthRedirect = () => {
  useEffect(() => {
    const nextUrl = encodeURIComponent(window.location.href);
    window.location.replace(
      `${window.config.authApiUrl}/auth/eduidp?next=${nextUrl}`
    );
  }, []);

  return null;
};

export default AuthRedirect;